import { render, staticRenderFns } from "./integralPeopleItemAdd.vue?vue&type=template&id=140dc9bb&scoped=true&"
import script from "./integralPeopleItemAdd.vue?vue&type=script&lang=js&"
export * from "./integralPeopleItemAdd.vue?vue&type=script&lang=js&"
import style0 from "./integralPeopleItemAdd.vue?vue&type=style&index=0&id=140dc9bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140dc9bb",
  null
  
)

export default component.exports